/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProjectDomain } from './ProjectDomain';
import {
    instanceOfProjectDomain,
    ProjectDomainFromJSON,
    ProjectDomainFromJSONTyped,
    ProjectDomainToJSON,
} from './ProjectDomain';

/**
 * @type OtherSystemSourceWithCentreAndDomainProjectDomain
 * 
 * @export
 */
export type OtherSystemSourceWithCentreAndDomainProjectDomain = ProjectDomain;

export function OtherSystemSourceWithCentreAndDomainProjectDomainFromJSON(json: any): OtherSystemSourceWithCentreAndDomainProjectDomain {
    return OtherSystemSourceWithCentreAndDomainProjectDomainFromJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainProjectDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceWithCentreAndDomainProjectDomain {
    if (json == null) {
        return json;
    }
    if (instanceOfProjectDomain(json)) {
        return ProjectDomainFromJSONTyped(json, true);
    }

    return {} as any;
}

export function OtherSystemSourceWithCentreAndDomainProjectDomainToJSON(json: any): any {
    return OtherSystemSourceWithCentreAndDomainProjectDomainToJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainProjectDomainToJSONTyped(value?: OtherSystemSourceWithCentreAndDomainProjectDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfProjectDomain(value)) {
        return ProjectDomainToJSON(value as ProjectDomain);
    }

    return {};
}

